import type { FormVariant } from '@/components/pages/form/type';

/**
 * A distinct `data-form-variant` for the mass-tort hero form, so its CSS (scoped to
 * `.mass-tort-form`) never inherits the variables a `default`-themed form on the same page
 * would set. No variant chunk is registered — the look is all local CSS.
 *
 * Kept in this neutral (non-`'use client'`) module so the server `form.tsx` and the client
 * `form-client.tsx` can both import the actual value; importing it from the client module into
 * the server component would hand back a client reference instead of the string.
 */
export const MASS_TORT_VARIANT = 'mass-tort' as unknown as FormVariant;
